<template>
  <div class="base">
    <span style="display: inline-flex;" class="alinha-v">
      <slot name="leading">  </slot>
      <h4>{{ param.description }}</h4>
    </span>
    <slot name="trailing"> </slot>
  </div>
</template>

<script>
export default {
  props: {
    param: { type: Object, required: true },
  },
  data() {
    return {};
  },
};
</script>

<style>
.base {
  margin: 16px 6px;
  display: flex;
  justify-content: space-between;
}
</style>
